import React from "react";
import { Link } from "react-router-dom";


export default class Header extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">  
                    <div class="header-part">
                        <div class="container">
                            <div class="menu-part-outer">
                            <div class="menu-part">
                                <ul>

                                    <li class="active"><Link to={'/home'}>Home</Link></li>
                                    <li><Link to={'/aboutus'}>About Us</Link></li>                           
                                    <li class="has-child"><Link to={'/menu'}>Menu</Link></li>
                                    <li class="logo"><Link to={'/foodtrucks'}></Link></li>
                                    {/* <li class="has-child">
                                        <Link to={'/events'}>events<span class="caret"></span></Link>
                                        <ul class="sub-menu">
                                        <li><Link to={'/eventdetails'}>event detail</Link></li>
                                        </ul>
                                    </li> */}
                                    <li><Link to={'/subscription'}>Subscription</Link></li>

                                    {/* <li class="has-child">
                                        <Link to={'/news'}>News <span class="caret"></span></Link>
                                        <ul class="sub-menu">
                                        <li><Link to={'/newsdetail'}>News Detail</Link></li>
                                        </ul>
                                    </li> */}
                                    <li><Link to={'/events'}>events</Link></li>

                                    <li><Link to={'/contact'}>contact</Link></li>
                                    {/* <li><Link to={'/aboutus'}>aboutus</Link></li> */}

                                </ul>
                            </div> {/* <!-- menu-part --> */}
                            <div class="logo-header">
                                <a href="index.html"><img src="images/footer-logo.png" alt=""/></a>
                            </div> {/* <!-- logo-header --> */}
                            <div id="page">
                                <div class="header">
                                {/* <a href="#menu"></a> */}
                                </div>
                                <nav id="menu">
                                <ul>
                                    <li><a href="index.html" title="Home">Home</a></li>
                                    <li><a href="menu.html" title="Menu">Menu</a></li>
                                    <li><a href="truck-locator.html" title="Truck locator">Truck locator</a></li>
                                    <li>
                                        <a href="event.html" title="events">events</a>
                                        <ul>
                                            <li><a href="event-detail.html">event detail</a></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="news.html" title="News">News</a>
                                        <ul>
                                            <li><a href="post-detail.html">News Detail</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="contact.html" title="contact">contact</a></li>
                                    <li><a href="contact.html" title="aboutus">aboutus</a></li>
                                </ul>
                                </nav>
                            </div>
                            </div> {/* <!-- menu-part-outer --> */}
                        </div>   {/* <!-- container --> */}
                    </div>
                </div>
            </div>
        )
    }
}